import { useEffect, useState } from "react"

export const useCheckIfInIFrame = () => {
  const [inIFrame, setInIFrame] = useState(false)

  useEffect(() => {
    try {
      setInIFrame(
        window?.self?.location?.hostname !== window?.top?.location?.hostname
      )
    } catch (error) {
      setInIFrame(false)
      console.error("Cross-origin access")
    }
  }, [])

  return inIFrame
}
